// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"IN-z","upvoteIcon":"JN-z","downvoteIcon":"KN-z","feedbackIcon":"LN-z"};